import onlineApplicationAssessmentI18N from "./online_application/sbca_assessment.json";
import onlineApplicationAssessmentSBCAThankYou from "./online_application/sbca_thank_you.json";

const enPagesI18n = {
  ...onlineApplicationAssessmentI18N,
  ...onlineApplicationAssessmentSBCAThankYou,
};

export default enPagesI18n;
